import React from 'react';
import { DisabilityComponent } from './Disability.Component';
import { httpServices } from '../../../../services/httpServices';

const formFields = {
    'id':0,
    'disability_type': null,
    'start_date': null,
    'end_date': null,
    'paycheck_start_date': null,
    'paycheck_end_date' : null,
    'deduction_components':null,
    'ctc_components':null,
};

export class Disability extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            disability_benefits: [],
            title : 'Disability',
            formFields: formFields,
            open: false,
            isEditable: false,
            errors: {},
            editBasic: false,
            Open: false,
        }
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleOnChange = (evt, value) => {
        const field = evt.target.name;
        if (field === 'family_id') {
            this.setState({'family_id': evt.target.value});
        }

        else {
            const ff = this.state.formFields;
            ff[field] = evt.target.value;
            this.setState({ 
                formFields: ff
            });
        }
    };

    handleSubmit = (event) => {
        if(this.handleValidation()){
            let data = this.state.formFields;
            if (data) {
                data.staff_id = this.props.StaffID;
                httpServices.post('api/staff/benefit/add-Disability', { data })
                    .then(response => {
                        if (!response.data.errors) {
                            if (response.data) {
                                if(data.id){
                                    let details = response.data.disability_details;
                                    this.setState({disability_benefits:details, Open: false});
                                    alert("Disability details updated successfully");
                                } else {
                                    let details = response.data.disability_details;
                                    this.setState({
                                        disability_benefits:details,
                                        Open: false,
                                    });
                                    alert("Disability details saved successfully");
                                }
                            }
                            else
                            {
                                const ff = this.state.errors;
                                ff['disability_overlap'] = "Disability already exist for this period";
                                this.setState({ Open:true,errors:ff});
                            }
                        }
                        else {
                            this.setState({ errors : response.data.errors});
                        }
                    })
                    .catch(function(error) {
                        console.log("error" + error);
                    });
            }
        
        }
    };

    onAdd = () => {
        this.clearForm();
        if (this.state.disability_benefits.length===0){   
           this.setState({disability_benefits : this.props.disability_benefits});
        }
        this.setState({
            Open: true,
            editBasic: false,
        });
    };

    clearForm = () => {
        const ff = {
             'id':0,
             'disability_type': null,
             'start_date': null,
             'end_date': null,
             'paycheck_start_date': null,
             'paycheck_end_date': null,
             'deduction_components':null,
             'ctc_components':null,
          };

        this.setState({
            errors: {},
            errorMessage: false,
            formFields: ff,
            isEditable: false,
        });
    };
    
    onClose = (isBasicEdit) =>{
        this.clearForm();
        this.setState({
            Open: false,
            editBasic: false
        });
    };
    
    onUpdate = (id) => {
        if (this.state.disability_benefits.length===0){
            this.setState({disability_benefits : this.props.disability_benefits});
        }
        return httpServices.post('api/staff/benefit/get-disability-details-by-id', {'id': id})
            .then(response => {

                if (response.data) {
                    let data = response.data;
                    if (Object.keys(data).length){
                        const inputs = {
                            'id': data.id,
                            'disability_type': data.disability_type_id,
                            'start_date': data.start_date,
                            'end_date': data.end_date,
                            'paycheck_start_date': data.paycheck_start_date,
                            'paycheck_end_date': data.paycheck_end_date,
                            'monthly_prem_employee':data.monthly_premium_employee,
                            'monthly_prem_family':data.monthly_premium_family,
                            'employer_contrib_employee':data.employer_contrib_employee,
                            'employer_contrib_family':data.employer_contrib_family,
                            'employee_contrib_employee':data.employee_contrib_employee,
                            'employee_contrib_family':data.employee_contrib_family,
                            'deduction_components':data.ded_component_id,
                            'ctc_components':data.ctc_component_id,
                        };
                        this.setState({
                            formFields: inputs,
                            Open: true,
                            editBasic : true,
                            id: data.id,
                        });
                    }
                }
        })
        .catch(function(error) {
            console.log("Error: "+error);
        });
    }

    onDelete = (rowID) => {
        return httpServices.post('api/staff/benefit/delete-disability', {'id': rowID, 'staff_id': this.props.StaffID})
            .then(response => {
                if (response.data.valid) {
                    this.setState({disability_benefits:response.data.disability_benefits});
                    alert("Disability details deleted successfully");
                }
                else{
                    alert("You cannot delete this Disability component. Payroll(s) already generated with this component");
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }
 
    handleValidation() {
        let formIsValid = true;
        let errors = {};
        if (!this.state.formFields.start_date) {
            errors["start_date"] = "Cannot be empty";
            formIsValid = false;
        }
        else 
        {
            let start_date = new Date(this.state.formFields.start_date);
            let join_date = new Date(this.props.staff_join_date);
            if(start_date < join_date){
                errors["start_date"] = "Start date cannot be before joining date";
                formIsValid = false;
            }
        }
        if (!this.state.formFields.disability_type) {
            errors["disability_type"] = "Cannot be empty";
            formIsValid = false;
        }
        if (!this.state.formFields.paycheck_start_date) {
            errors["paycheck_start_date"] = "Cannot be empty";
            formIsValid = false;
        }
        if(this.state.formFields.start_date && this.state.formFields.end_date){
            let start_date = new Date(this.state.formFields.start_date);
            let end_date = new Date(this.state.formFields.end_date);
            if(start_date > end_date){
                errors["end_date"] = "End date cannot be before start date";
                formIsValid = false;
            }
        }
        if(this.state.formFields.paycheck_start_date && this.state.formFields.paycheck_end_date){
            let paycheck_start_date = new Date(this.state.formFields.paycheck_start_date);
            let paycheck_end_date = new Date(this.state.formFields.paycheck_end_date);
            if(paycheck_start_date > paycheck_end_date){
                errors["paycheck_end_date"] = "End date cannot be before start date";
                formIsValid = false;
            }
        }
        this.setState({errors: errors});
        return formIsValid;
    }

    render(){
        return(
            <DisabilityComponent
               Title={this.state.title}
               FormFields={this.state.formFields}
               disability_benefits = {(this.state.disability_benefits) && (this.state.disability_benefits.length > 0)  ? this.state.disability_benefits:this.props.disability_benefits}
               disability_type = {this.props.disability_type}
               disability_deduction_components = {this.props.disability_deduction_components}
               disability_ctc_components = {this.props.disability_ctc_components}
               StaffID = {this.props.StaffID} 
               OnSubmit={this.handleSubmit} 
               IsEditBasic={this.state.editBasic}
               HandleOnChange={this.handleOnChange}
               OnAdd={this.onAdd.bind(this)}
               OnDelete={this.onDelete.bind(this)}
               Open= {this.state.Open} 
               OnClose={this.onClose.bind(this)}
               OnUpdate={this.onUpdate.bind(this)} 
               Errors={this.state.errors}
            />
        )
    }
}
